import { render, staticRenderFns } from "./NameStatusEstatePlanning.vue?vue&type=template&id=b0b2c8d6"
import script from "./NameStatusEstatePlanning.vue?vue&type=script&lang=js"
export * from "./NameStatusEstatePlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports